module.exports = __webpack_public_path__ + "img/alipay-qrcode.74ca8e01.svg";